import Builder, { initialValues as builderInitialValues } from './Builder';
import Player from './Player';

export default {
    handle: 'groupMeans',
    label: 'Average Group Scores',
    builderInitialValues,
    builder: Builder,
    player: Player,
};
